import React from 'react';
import { Link } from 'react-router-dom';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import ActionCard from './ActionCard';
import AssistantMarkdown from './AssistantMarkdown';

/* One turn in the conversation: the text, any cards, and any page links. */
const AssistantMessage = ({ message }) => {
    const fromAgent = message.role === 'assistant';
    return (
        <div className={`assistant-msg is-${message.role}${message.failed ? ' is-failed' : ''}`}>
            {fromAgent && <span className="assistant-msg-avatar" aria-hidden="true"><AutoAwesomeRoundedIcon /></span>}
            <div className="assistant-msg-stack">
                {message.content && (
                    <div className="assistant-bubble" role={message.failed ? 'alert' : undefined}>
                        {fromAgent && !message.failed ? <AssistantMarkdown content={message.content} /> : message.content}
                    </div>
                )}
                {(message.actions || []).map((action) => <ActionCard key={action.id} action={action} />)}
                {message.links && message.links.length > 0 && (
                    <div className="assistant-links">
                        {message.links.map((link) => <Link key={link.path} to={link.path}>{link.label}</Link>)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AssistantMessage;
